import { Injectable } from '@angular/core';
import { ModulesManagerService } from './modules-manager.service';
import { SqliRequest } from '../SqliRequest/sqli-request';
import { LoggerService } from '../../utils/logger.service';

@Injectable({
  providedIn: 'root'
})
export class OfflineService {
  private manager: ModulesManagerService;

  constructor() { }

  initiate(manager: ModulesManagerService) {
    this.manager = manager
  }



  async ModuleUsersOffline(Action, Data) {
    switch (Action) {
      case "Login":
        let resu = await this.manager.Sqli.executeSql("select * from login where Email=? and Password=?", [Data.Email, this.manager.Tool.encrypt(Data.Password)]).catch((e) => { return { rows: [] } })
        if (resu.length > 0) {
          resu = await this.manager.Sqli.executeSql("select * from users where Email = ?", [Data.Email]).catch((e) => {
            LoggerService.error("OfflineService executeSql error:", e)
            return []
          })
          if (resu.length) {
            this.manager.Usr.loadData({ Data: resu[0] })
          }
          return { success: "STR_CONNECTED" }
        } else {
          return { error: "STR_WRONG_CREDITENTIAL" }
        }
      case "Register":
        return { error: "STR_UNABLE_OFFLINE" }
    }
  }

  public async OnEvent(Modul, Action, Data) {
    switch (Modul) {
      case "Users":
        return await this.ModuleUsersOffline(Action, Data)
    }
    return false
  }

  public async GenerateLocalDatabase() {
    while (!this.manager?.Sqli) await new Promise((resolve) => setTimeout(resolve, 500))
    let SqliRequests: Array<SqliRequest> = []
    if (! await this.manager.Sqli.executeSql("select * from login").catch((e) => { return false }))
      SqliRequests.push(new SqliRequest("create table login("
        + "`Id` INTEGER PRIMARY KEY,"
        + "`Email` TEXT  NOT NULL DEFAULT '',"
        + "`Password` TEXT  NOT NULL DEFAULT ''"
        + ")"))
    if (! await this.manager.Sqli.executeSql("select * from users").catch((e) => { return false }))
      SqliRequests.push(new SqliRequest("create table users("
        + "`Id` INTEGER PRIMARY KEY,"
        + "`Email` TEXT  NOT NULL DEFAULT '',"
        + "`FirstName` TEXT  NOT NULL DEFAULT '',"
        + "`LastName` TEXT  NOT NULL DEFAULT '',"
        + "`PhoneNumber` TEXT  NOT NULL DEFAULT '',"
        + "`Language` TEXT  NOT NULL DEFAULT '',"
        + "`Society` TEXT  NOT NULL DEFAULT '',"
        + "`DisplayPhoneNumber` NUMERIC  NOT NULL DEFAULT 0"
        + ")"))
    await this.manager.Sqli.executeMultiSql(SqliRequests)
  }

  public async SaveCombotLogin(email: string, password: string) {

    let result = await this.manager.Sqli.executeSql('select * from login where Email = ?', [email]).catch(() => [])
    if (!result.length) {
      await this.manager.Sqli.executeSql("insert into login (Email, Password) values ( ?, ?)", [email, this.manager.Tool.encrypt(password)])
    }
  }

}
